"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Phone, Calendar } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactPrompt() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className={`py-16 px-4 bg-background transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
      <div className="max-w-2xl mx-auto">
        <div className="bg-background-card rounded-xl shadow-soft p-8 md:p-12 text-center">
          <h2 className="text-2xl md:text-3xl font-display font-semibold text-foreground mb-4">
            Ready to Schedule Your Visit?
          </h2>
          <p className="text-foreground-body text-base md:text-lg mb-8">
            Our team at Alpha Dental is here to provide you with exceptional dental care. 
            Call us directly or book your appointment online today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="tel:2107755177">
              <Button size="lg" className="w-full sm:w-auto group relative overflow-hidden">
                <span className="absolute inset-0 rounded-md border-2 border-transparent group-hover:border-secondary transition-all duration-[80ms]" />
                <Phone className="size-5" />
                Call Now
              </Button>
            </Link>
            <Link to="https://www.appointnow.com/?P=4826&O=101&PT=0&campaignID=" newTab>
              <Button size="lg" className="w-full sm:w-auto group relative overflow-hidden">
                <span className="absolute inset-0 rounded-md border-2 border-transparent group-hover:border-secondary transition-all duration-[80ms]" />
                <SafeHydrate><Calendar className="size-5" /></SafeHydrate>
                Schedule With Us
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}